exports.Ages = [
  '',
  'All Ages',
  'All Ages to Enter, 21 & Over to Drink',
  '21 & Over',
  '19 & Over',
  '18 & Over',
  '16 & Over',
  'Over 19s Only',
  'Over 18s Only',
  'Over 16s Only',
  'Over 14s Only',
  '14 & Over',
  'All Ages (Mature Content)',
  '15 & Over',
  'Guests Under 18 Require Accompanying Adult',
  '18 & Over with Valid Government ID',
  '17+',
  'All Ages (under 16 with adult)',
  '1+',
  '2+',
  '3+',
  '4+',
  '5+',
  '6+',
  '7 & Over',
  '12 & Over',
  '13 & Over',
];

exports.Status = [
  ['Buy Tickets', 1],
  ['Cancelled', 2],
  ['Free', 3],
  ['Postponed - DO NOT Allow Sales', 5],
  ['Postponed - Allow Sales', 37],
  ['Rescheduled - New Date', 6],
  ['Rescheduled - New Date and Venue', 38],
  ['Suspended', 36],
  ['Sold Out', 7],
  ['TBD', 8],
  ['Free *', 9],
  ['Private', 10],
  ['Venue Change', 11],
  ['Unavailable', 12],
  ['By Phone Only', 13],
  ['Box Office Only', 14],
  ['Buy Admission', 27],
];

exports.Category = [
  ['Music', 2],
  ['Sports', 3],
  ['Arts & Family', 1],
];

//Genre options for Arts & Family
exports.Genre1 = [
  ['Theater', 1],
  ['Circus', 2],
  ['Expo/Convention', 3],
  ['Fairs and Festivals', 4],
  ['Lectures and Seminars', 5],
  ['Museums and Exhibits', 6],
  ['Other', 7],
  ['Opera', 8],
  ['Family Events', 9],
  ['Comedy', 14],
];

exports.DefaultGenre1 = 1;

//Genre options for Music
exports.Genre2 = [
  ['Alternative / Punk', 10],
  ['Award Shows', 51],
  ['Christian', 11],
  ['Classical', 13],
  ['Country', 15],
  ['Dance / Electronic', 17],
  ['Festivals', 18],
  ['Folk / Acoustic', 19],
  ['Hard Rock / Metal', 22],
  ['Hip Hop / Rap', 20],
  ['Indie / Emo', 21],
  ['International', 16],
  ['Jazz / Blues', 23],
  ['Kpop', 49],
  ['Latin', 24],
  ['Other', 28],
  ['Pop', 25],
  ['R&B', 26],
  ['Reggae', 27],
  ['Rock', 12],
];

exports.DefaultGenre2 = 10;

//Genre options for Sports
exports.Genre3 = [
  ['Award Shows', 50],
  ['Baseball', 44],
  ['Basketball', 29],
  ['Boxing', 30],
  ['Competitions', 31],
  ['Cycling', 41],
  ['eSports', 48],
  ['Extreme Sports', 32],
  ['Festivals', 40],
  ['Football', 33],
  ['Golf', 66],
  ['Hockey', 34],
  ['Mixed Martial Arts', 42],
  ['Motorsports', 35],
  ['Other Sports', 36],
  ['Rugby', 37],
  ['Soccer', 38],
  ['Tennis', 43],
  ['WWE / WWF', 39],
];

exports.DefaultGenre4 = 67;

exports.Genre4 = [
  ['Arts', 73],
  ['Comedy', 69],
  ['Kids & Family', 70],
  ['Music', 67],
  ['Religion & Spirituality', 75],
  ['Sports', 72],
  ['Technology', 74],
  ['True Crime', 71],
  ['TV & Movies', 68],
];

exports.eventConcurrencyCopy =
  'Someone else saved changes while you were editing. If you save, their changes will be lost.';
exports.zoneConcurrencyCopy =
  'Someone else saved changes while you were editing. If you save, their changes will be lost.';
exports.priceChartConcurrencyCopy =
  'Someone else saved changes while you were editing. If you save, their changes will be lost.';

exports.DefaultGenre3 = 29;

exports.DEFAULT_FREE_FORM_ID_PREFIX = 999999999999;

exports.safetyIcons = [
  {
    name: 'Safety Modal Enabled',
    id: 0,
    fullWidth: true,
  },
  {
    name: 'Social Distancing',
    id: 1,
  },
  {
    name: 'Masks Encouraged',
    id: 2,
  },
  {
    name: 'Paperless Entry',
    id: 3,
  },
  {
    name: 'Temperature Check',
    id: 4,
  },
  {
    name: 'Guaranteed Tickets',
    id: 5,
  },
  {
    name: 'Hand Sanitizer',
    id: 6,
  },
  {
    name: 'Contactless Pay',
    id: 7,
  },
  {
    name: 'Venue Sanitization',
    id: 8,
  },
  {
    name: 'Masks Required',
    id: 9,
  },
  {
    name: 'Clear Bag Policy',
    id: 10,
  },
  {
    name: 'Proof of Vaccine',
    id: 11,
  },
  {
    name: 'Proof of Negative Test or Vaccination',
    id: 12,
  },
  {
    name: 'Proof of Full Vaccination',
    id: 13,
    fullWidth: true,
  },
];



// WEBPACK FOOTER //
// ./src/routes/EventDetails/constants/index.js